/**
 * Format a number as currency using EU format
 *
 * @param {number} amount - The amount to format
 * @param numberOfDecimal
 * @param currency
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount, numberOfDecimal = 2, currency) => {
   var locale = 'de-DE';
   if (currency = "£") {
       locale = 'en-EN';
   }
    if (amount === null || amount === undefined || isNaN(amount)) {
        return `0,00`;
    }
    const formatter = new Intl.NumberFormat(locale, {
        minimumFractionDigits: numberOfDecimal,
        maximumFractionDigits: numberOfDecimal,
    });

    return `${formatter.format(amount)}`;
};

/**
 * Parse a formatted currency string back to a number
 *
 * @param {string} formattedAmount - The formatted currency string
 * @returns {number} The parsed amount
 */
export const parseCurrency = (formattedAmount) => {
    if (!formattedAmount) return 0;

    // Remove currency symbol and non-numeric characters except decimal separator
    const numericString = formattedAmount
        .replace(/[^0-9,.-]/g, '')
        .replace(',', '.');

    return parseFloat(numericString) || 0;
};
